var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"headline font-weight-bold align-baseline",class:{ 'px-7 px-lg-0 pt-5 mb-3': !_vm.classes, [_vm.classes]: _vm.classes }},[(!_vm.loading)?[_vm._t("default")]:_c('v-skeleton-loader',{attrs:{"type":"heading"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }